import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVisaCountry, IVisaCountryState } from "./visacountryModel";
import {
  createVisaCountry,
  deleteVisaCountry,
  getAllActiveVisaCountries,
  getAllVisaCountries,
  getVisaCountryByID,
  getVisaCountryWiseDocumentData,
  updateVisaCountry,
  visacountryActiveInactive,
} from "./services/visacountry.services";

const initialState: IVisaCountryState = {
  loading: false,
  formLoading: false,
  error: "",
  VisaCountryList: [],
  VisaDocumentList: [],
  VisaCountryID: null,
  VisaCountryDetail: {
    VisaCountry: "",
    CurrencyCode: "",
    DocumentID: [],
    IsActive: 1,
  },
};

const visaCountrySlice = createSlice({
  name: "visacountry",
  initialState,
  reducers: {
    clearVisaCountryDetails: (state) => {
      state.VisaCountryDetail = initialState.VisaCountryDetail;
    },
    setVisaCountryID: (state, action) => {
      state.VisaCountryID = action.payload;
    },
    clearVisaCountryID: (state) => {
      state.VisaCountryID = initialState.VisaCountryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVisaCountries.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVisaCountries.fulfilled,
      (state, action: PayloadAction<IVisaCountry[]>) => {
        state.loading = false;
        state.VisaCountryList = action.payload || [];
      }
    );
    builder.addCase(getAllVisaCountries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaCountryList = [];
    });
    builder.addCase(getAllActiveVisaCountries.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVisaCountries.fulfilled,
      (state, action: PayloadAction<IVisaCountry[]>) => {
        state.loading = false;
        state.VisaCountryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveVisaCountries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaCountryList = [];
    });
    builder.addCase(createVisaCountry.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVisaCountry.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVisaCountry.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVisaCountry.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVisaCountry.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVisaCountry.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVisaCountry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVisaCountry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVisaCountry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(visacountryActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(visacountryActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(visacountryActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVisaCountryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVisaCountryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VisaCountryDetail = action.payload;
    });
    builder.addCase(getVisaCountryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VisaCountryDetail = initialState.VisaCountryDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getVisaCountryWiseDocumentData.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getVisaCountryWiseDocumentData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.VisaDocumentList = action.payload || [];
      }
    );
    builder.addCase(
      getVisaCountryWiseDocumentData.rejected,
      (state, action) => {
        state.loading = false;
        state.VisaDocumentList = [];
        state.error = action.error.message || "Something went wrong";
      }
    );
  },
});

export const { clearVisaCountryDetails, setVisaCountryID, clearVisaCountryID } =
  visaCountrySlice.actions;
export default visaCountrySlice.reducer;
